import type { Bundle } from '../types'

/** Libellés du menu latéral et titres d'écran associés. */
export const nav = {
  'nav.section.monitoring': { fr: 'Surveillance', en: 'Monitoring' },
  'nav.section.advertising': { fr: 'Publicité', en: 'Advertising' },
  'nav.section.betting': { fr: 'Paris & jeux', en: 'Betting & gambling' },
  'nav.section.configuration': { fr: 'Configuration', en: 'Configuration' },
  'nav.section.help': { fr: 'Aide', en: 'Help' },

  'nav.overview': { fr: "Vue d'ensemble", en: 'Overview' },
  'nav.merchants': { fr: 'Marchands', en: 'Merchants' },
  'nav.merchants.portfolio': { fr: 'Portefeuille', en: 'Portfolio' },
  'nav.merchants.reports': { fr: 'Rapports de crawl', en: 'Crawl reports' },
  'nav.discovery': { fr: 'Usurpation de marques', en: 'Brand impersonation' },
  'nav.webscan': { fr: 'Marchands non déclarés', en: 'Undeclared merchants' },
  'nav.ads': { fr: 'Détection pubs', en: 'Ad detection' },
  'nav.ads.overview': { fr: "Vue d'ensemble", en: 'Overview' },
  'nav.ads.advertisers': { fr: 'Annonceurs', en: 'Advertisers' },
  'nav.ads.banners': { fr: 'Bannières sur les sites', en: 'Banners on websites' },
  'nav.ads.campaigns': { fr: 'Campagnes de scan', en: 'Scan campaigns' },
  'nav.ads.queries': { fr: 'Requêtes surveillées', en: 'Monitored queries' },
  'nav.betting': { fr: 'Paris & jeux', en: 'Betting & gambling' },
  'nav.betting.dashboard': { fr: 'Tableau de bord', en: 'Dashboard' },
  'nav.betting.tests': { fr: 'Tests de paiement', en: 'Payment tests' },
  'nav.betting.services': { fr: 'Services de paris', en: 'Betting services' },
  'nav.betting.discovery': { fr: 'Rechercher des sites', en: 'Find websites' },
  'nav.betting.qualify': { fr: 'À qualifier', en: 'To qualify' },
  'nav.betting.referentials': { fr: 'Référentiels', en: 'Reference data' },
  'nav.brands': { fr: 'Modèles de recherche', en: 'Search templates' },
  'nav.rules': { fr: 'Règles pays', en: 'Country rules' },
  'nav.users': { fr: 'Utilisateurs', en: 'Users' },
  'nav.orgs': { fr: 'Organisations', en: 'Organisations' },
  'nav.guide': { fr: 'Guide utilisateur', en: 'User guide' },
} satisfies Bundle
